<template>
  <div class="preventiva-os_erp ml-4 mr-4" >
          <b-form>          
          <b-row>
              <b-col>
                <label for="select-garagem">Garagem</label> 
                <multiselect id="cmbgaragem" 
                v-model="value_garagem"  required
                :options="garagens"  size="sm" 
                :multiple="false" :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" 
                :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>                                        
                </multiselect> 
              </b-col>
            
            <!--
              filtros dos serviços
            -->
              <b-col>
                <label for="select-servico">Serviço</label>
                <multiselect  v-model="value_servico" required :options="servicos" :multiple="false" :close-on-select="false" :clear-on-select="false" :preserve-search="true"   placeholder="Selecione o serviço" label="servico" track-by="servico" :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Servico selecionado</span></template>                                        
                </multiselect> 
              </b-col>            

              <b-col>
                <label for="select-status">Status</label>
                <multiselect  v-model="value_status" required :options="statuss" :multiple="false" :close-on-select="false" :clear-on-select="false" :preserve-search="true"   placeholder="Selecione o status" label="status" track-by="status" :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>                                        
                </multiselect> 
              </b-col>
            
              <b-col>
                   <div>                            
                        <label  for="datepicker-placeholder">Data inicio</label>
                        
                        <b-form-datepicker id="datepicker-placeholder" required  v-model="emissao_inicio" placeholder="Data inicio" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
              </b-col>

              <b-col>
                <div>                            
                    <label  for="datepicker-placeholder">Data Fim</label>
                    <b-form-datepicker id="datepicker-placeholder2" required v-model="emissao_fim" placeholder="Data fim" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col>
                  <b-form-group label="Qtd serviços:" label-for="preventiva-historico">
                      <b-form-input id="preventiva-historico" type="text"                       
                        placeholder="Qtd" readonly />
                  </b-form-group>
              </b-col>            

              <b-col>
                  <b-form-group label="Valores Gastos R$.:" label-for="preventiva-historico">
                      <b-form-input id="preventiva-historico" type="text"                       
                        placeholder="Gastos R$.."  readonly/>
                  </b-form-group>
              </b-col>              

              <b-col>
                <b-form-group label="Pesquisar" label-for="preventiva-historico"   >
                  <b-form-input id="preventiva-historico" type="text"                       
                        placeholder="Pesquisar no grid." />
                  </b-form-group>               
              </b-col>

              <!-- botão para acionar a pesquisa -->
              <b-col>
                <br>                
                <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadPreventivaMonitoramentos()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>              
          </b-row>
    </b-form>

       <!-- <br>
        {{'Carro.: '+ preventivamonitoramento.carro + ' Serviço.: ' +  preventivamonitoramento.os_erp}}
-->
        <b-table small hover striped sticky-header="530px"  :items="preventivamonitoramentos" :fields="fields"> 
          <template slot="cell(actions)" slot-scope="data"  >
            
            <b-button @mouseup="loadCarregaOs(data.item)" @click="modalShowTarefas = !modalShowTarefas,loadPreventivasOsTarefas()" title="Tarefas"  size="sm" variant="success" class="mr-2">                
              <i class="fa fa-tasks"></i>
            </b-button>            

            <b-button @mousemove="loadCarregaOs(data.item)" @click="modalShowPecas = !modalShowPecas,loadPreventivasOsPecas(),loadPreventivasOsPecas()"  title="Peças utilizadas" size="sm" variant="danger" class="mr-2">
              
              <i class="fa fa-gear"></i>
            </b-button>
          </template>
        </b-table>    

        <!--Modal Tarefas -->
        <div>
            <b-modal v-model="modalShowTarefas" id="consumo-tarefas" size="xl" title="Tarefas associadas">     
              {{loadPreventivasOsTarefas()}}     
              <font color="blue"> {{'Carro.: '+preventivamonitoramento.carro + ' - Serviço.: ' + preventivamonitoramento.id_servico+'-'+preventivamonitoramento.servico }}</font>  
              <div class="modal-body" modal-body>            
                <b-table  small hover striped sticky-header="530px" :items="loadPreventivasostarefas" :fields="fieldstarefas">
                </b-table> 
              </div>          
            </b-modal> 
        </div>
        

        <!-- Modal pecas -->
        <div>
          <b-modal  v-model="modalShowPecas"  ref="consumo-pecas"  size="xl" title="Peças utilizadas ">           
            <font color="blue"> {{'Carro.: '+preventivamonitoramento.carro+ ' Serviço.: ' + preventivamonitoramento.id_servico+'-'+preventivamonitoramento.servico }}</font>                                     
            <div >                 
              <b-table  v-model="tablepecas"  small hover striped sticky-header="530px"  :fields="fieldspecas"  :items="loadPreventivasospecas" >                 
              </b-table>
            </div>

            <template #modal-footer="{ cancel }">              
              <!-- Button with custom close trigger value -->
              <b-button size="sm" block variant="outline-primary" @click="cancel()">
                Voltar
              </b-button>
            </template>
            
          </b-modal>
        </div>
      
        
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
    name: 'PreventivaAdmin',
    data: function() {
        return {
         
            //modalShowPecas: false,             
            mode: 'save',
            carregando: false,
            garagem:{},
            garagens: [],  
            value_garagem:[],// [] lista        

            servico:{},
            servicos: [],  
            value_servico:[],// [] lista  

            status:{},
            statuss: [],  
            value_status:[],// [] lista  
            emissao_inicio: '',      
            emissao_fim: '',   

            preventivamonitoramento: {}, 
            preventivamonitoramentos:[], // array de preventiva

            preventivasospeca: {},
            preventivasospecas: [],

            Preventivasostarefa: {},
            Preventivasostarefas: [],


            fields: [              
                { key: 'os_erp', label: 'Nro O.S', sortable: true },   
                { key: 'dt_emissao', label: 'Emissão', sortable: true, formatter: (value, key, preventivamonitoramentos) => {
                    return moment(preventivamonitoramentos.dt_emissao).format('DD/MM/YYYY');} },
                { key: 'carro', label: 'Carro', sortable: true },  
                { key: 'servico', label: 'Serviço', sortable: true }, 
                { key: 'limite', label: 'Limite', sortable: true }, 
                { key: 'executado', label: 'Executado', sortable: true }, 
                { key: 'diferenca', label: 'Diferença', sortable: true }, 
                { key: 'dt_inicio_servico', label: 'Inicio', sortable: true, formatter: (value, key, preventivamonitoramentos) => {
                    return moment(preventivamonitoramentos.dt_inicio_servico).format('DD/MM/YYYY HH:mm').replace('Invalid date','-') ; }  },                   
                
                { key: 'dt_fim_servico', label: 'Término', sortable: true, formatter: (value, key, preventivamonitoramentos) => {
                    return moment(preventivamonitoramentos.dt_fim_servico).format('DD/MM/YYYY HH:mm').replace('Invalid date','-') ; }  },
                { key: 'status', label: 'Status', sortable: true },
                { key: 'total_os', label: 'R$ Pecas', sortable: true },
                { key: 'fechado_via', label: 'Fechado Via', sortable: true },
                { key: 'actions', label: 'Ações' },
            ],


            /////////////////////////////////////////////////
            ////////////////////////////////////////////////
            fieldspecas: [                              

                { key: 'data_mov', label: 'Dt_movimento', sortable: true, formatter: (value, key, preventivasospecas) => {
                    return moment(preventivasospecas.data_mov).format('DD/MM/YYYY').replace('Invalid date','-') ; }  },   

                { key: 'carro', label: 'carro', sortable: true },              
                { key: 'modelo_chassi', label: 'modelo_chassi', sortable: true },
                { key: 'rotina', label: 'rotina', sortable: true },                
                { key: 'requisicao', label: 'requisicao', sortable: true },                
                { key: 'quantidade', label: ' quantidade', sortable: true },
                { key: 'material', label: 'material', sortable: true },
                { key: 'valor_unitario', label: 'valor_unitario', sortable: true },
                { key: 'valor_total', label: 'valor_total', sortable: true },
                { key: 'os', label: 'os', sortable: true },
                { key: 'requisitante', label: 'requisitante', sortable: true },
                
               
            ],
                        
            
            



            /////////////////////////////////////////////////
            ////////////////////////////////////////////////
            fieldstarefas: [                
                
               // { key: 'dt_emissao', label: 'dt_emissao', sortable: true, formatter: (value, key, preventivasostarefas) => {
               //     return moment(preventivasostarefas.dt_emissao).format('DD/MM/YYYY').replace('Invalid date','-') ; }  },   

                { key: 'carro', label: 'carro', sortable: true },              
               // { key: 'servico', label: 'servico', sortable: true },
                { key: 'grupo', label: 'grupo', sortable: true },                
                { key: 'tarefa', label: ' tarefa', sortable: true },
                //{ key: 'encarregado', label: 'encarregado', sortable: true },
                
                //{ key: 'dt_delegado_app', label: 'Data delegado', sortable: true, formatter: (value, key, preventivasostarefas) => {
                //    return moment(preventivasostarefas.dt_delegado_app).format('DD/MM/YYYY HH:mm').replace('Invalid date','-') ; }  },  

                { key: 'status_tarefa_encarregado', label: 'status_encarregado', sortable: true },
                { key: 'executante', label: 'executante', sortable: true },

                { key: 'dt_termino_app', label: 'Data término', sortable: true, formatter: (value, key, preventivasostarefas) => {
                    return moment(preventivasostarefas.dt_termino_app).format('DD/MM/YYYY HH:mm').replace('Invalid date','-') ; }  },  


                { key: 'status_tarefa_executante', label: 'status_executante', sortable: true },
                { key: 'observacao', label: 'observacao', sortable: true },
            ],
        }        
    },
    

        components: {
        Multiselect
    },

    methods: {
        loadGaragens() {
          const url = `${baseApiUrl}/preventiva/garagem`
          axios.get(url).then(res => {
            this.garagens = res.data.map(garagem => {              
              return { id_garagem: garagem.id_garagem, garagem: garagem.garagem }
            })
          })
        },

        loadServicos() {
          const url = `${baseApiUrl}/preventiva/servico`
          axios.get(url).then(res => {
            this.servicos = res.data.map(servico => {              
              return { id_servico: servico.id_servico, servico: servico.denominacao }
            })
          })
        },

        loadStatuss() {
          const url = `${baseApiUrl}/preventiva/status`
          axios.get(url).then(res => {
            this.statuss = res.data.map(status => {              
              return { id_status: status.id_status, status: status.denominacao }
            })
          })
        },

        loadPreventivasOsPecas() {                        
             const url = `${baseApiUrl}/preventiva/pecas/${this.preventivamonitoramento.os_erp}`                               
            axios.get(url).then(res => {                                
                this.carregando = false;
                this.loadPreventivasospecas = res.data                
            })            
        },

        loadPreventivasOsTarefas() {                        
            const url = `${baseApiUrl}/preventiva/tarefas/${this.preventivamonitoramento.os_erp}`                               
            axios.get(url).then(res => {                                
                this.carregando = false;
                this.loadPreventivasostarefas = res.data       
          })  
        },


        loadPreventivaMonitoramentos() {
            const url = `${baseApiUrl}/preventiva/monitoramento/${this.value_garagem.id_garagem}/${this.value_servico.id_servico}/${this.value_status.id_status}/${this.emissao_inicio}/${this.emissao_fim}}`            
            axios.get(url).then(res => {              
                this.carregando = false;
                this.preventivamonitoramentos = res.data.map(preventivamonitoramento => {
                            return {                              
                              id_filial: preventivamonitoramento.id_filial, 
                              dt_emissao: preventivamonitoramento.dt_emissao, 
                              os_erp: preventivamonitoramento.os_erp,
                              carro: preventivamonitoramento.carro, 
                              id_servico: preventivamonitoramento.id_servico,
                              servico: preventivamonitoramento.servico, 
                              escalonamento: preventivamonitoramento.escalonamento,
                              limite: preventivamonitoramento.limite,
                              executado: preventivamonitoramento.executado, 
                              diferenca: preventivamonitoramento.diferenca, 
                              dt_inicio_servico: preventivamonitoramento.dt_inicio_servico, 
                              dt_fim_servico: preventivamonitoramento.dt_fim_servico, 
                              status: preventivamonitoramento.status,
                              total_os: preventivamonitoramento.total_os,
                              fechado_via: preventivamonitoramento.fechado_via
                            }              
                                                            })
                            })
        },

        loadCarregaOs(preventivamonitoramento){
            this.preventivamonitoramento = { ...preventivamonitoramento }
        },          
    },

    mounted() {
        this.loadGaragens()
        this.loadServicos()
        this.loadStatuss()        
        this.loadPreventivaMonitoramentos()
        this.loadCarregaOs()
        this.loadPreventivasOsPecas()
        this.loadPreventivasOsTarefas()          
    },

}



</script>

<style>
  .table{
      font-size: 0.7em;
      
  }

  .multiselect__option {
    font-size: 10px;    
  }

  span.multiselect__single{
    font-size: 10px;    
  }



</style>